import React from 'react';
import styled from 'styled-components';

const Div = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 5px;
`;

const Textarea = styled.textarea`
  border: 1px solid black;
  border-radius: 5px;
  padding: 10px;
  resize: none;
`;

export function TextArea(props) {
  const { label, id, value, onChange } = props;

  return (
    <Div>
      <label htmlFor={id}>{label}</label>

      <Textarea
        id={id}
        name={id}
        rows="5"
        cols="33"
        value={value}
        onChange={onChange}
        maxLength={2000}
      />
    </Div>
  );
}
